// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3J8_W","footer":"Form_footer__qzwlX"};